// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","qAndAList":"_21-x6_042d7tEtha8Naeig"};